import Swiper from "swiper";

export function getKiaBaseUrl() {
  return window.location.href.includes("https://www.kia.cn")
    ? "https://www.kia.cn"
    : "https://uat.kia.cn";
}

export function getMobileLoopAutoplayOptions(overrides = {}) {
  const { autoplay: overrideAutoplay = {}, pagination: overridePagination = {}, ...restOverrides } =
    overrides;
  return {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    //   ...overrideAutoplay,
    // },
    pagination: {
      type: "progressbar",
      ...overridePagination,
    },
    ...restOverrides,
  };
}

export function createSwiperInstance(containerEl, options = {}) {
  if (!containerEl) return null;
  return new Swiper(containerEl, options);
}

export function destroySwiperInstance(instance) {
  if (instance && typeof instance.destroy === "function") {
    instance.destroy(true, true);
  }
}

export function buildSwiperGroupImages(group, count = 3, bookedCount = 2, videoConfig = {}) {
  const total = Number(count) > 0 ? Number(count) : 3;
  const bookedTotal = Math.max(0, Math.min(total, Number(bookedCount) || 0));
  const slides = Array.from({ length: total }, (_, i) => i + 1);
  const getSharedVideoUrl = (videoItem) => {
    if (!videoItem) return "";
    if (typeof videoItem === "string") return videoItem;
    return videoItem.url || videoItem.pc || videoItem.mob || "";
  };
  return slides.map((slide, index) => ({
    index,
    type: slide <= bookedTotal ? "booked" : "coming",
    urlPc:
      slide <= bookedTotal
        ? `/assets/~/media/images/activity/202604suchao/pc/card-${slide}.png`
        : `/assets/~/media/images/activity/202604suchao/pc/card-default.png`,
    urlMob:
      slide <= bookedTotal
        ? `/assets/~/media/images/activity/202604suchao/mob/card-${slide}.png`
        : `/assets/~/media/images/activity/202604suchao/mob/card-default.png`,
    videoPc:
      slide <= bookedTotal ? getSharedVideoUrl(videoConfig[slide]) : "",
    videoMob:
      slide <= bookedTotal ? getSharedVideoUrl(videoConfig[slide]) : "",
  }));
}
